import React, { FC, Fragment } from 'react';
import { Typography } from '@material-ui/core';
import { find } from 'lodash';

import { SharesItemFragment } from 'api';
import { useSocialConnections } from 'hooks';
import { isUrl } from 'features/content/helpers';
import { getSocialAccountName } from 'helpers';

import UrlMetadata from './UrlMetadata';
import Body from './Body';

interface Props {
  item: SharesItemFragment;
}

const PastShareCell: FC<Props> = ({ item }) => {
  const { connections } = useSocialConnections();
  const { content } = item;

  function getSocialAccount() {
    const { network_id } = item;
    const account = find(connections, ['id', network_id]);

    return getSocialAccountName(account);
  }

  function getFallback() {
    return isUrl(content) ? (
      <UrlMetadata disableTitle content={content} />
    ) : (
      <Body content={content} />
    );
  }

  return (
    <Fragment>
      <Typography variant="body2">{getSocialAccount()}</Typography>
      <em>
        {!item.user_commentary ? getFallback() : <Typography>{item.user_commentary}</Typography>}
      </em>
    </Fragment>
  );
};

export default PastShareCell;
